import axios from 'axios';

import { Id, PagedParams, PagedResponse, getData } from '@feature/utils';

import { Journal, JournalRequest } from './JournalTypes';

export function getPaged(params: PagedParams) {
  return axios
    .get<PagedResponse<Journal>>('/journals/paged', {
      params,
    })
    .then(getData);
}

export function get(id: Id) {
  return axios.get<Journal>(`/journals/${id}`).then(getData);
}

export function edit(id: Id, request: JournalRequest) {
  return axios.put<Journal>(`/journals/${id}`, request).then(getData);
}

export function create(request: JournalRequest) {
  return axios.post<Journal>(`/journals`, request).then(getData);
}

export function deleteById(id: Id) {
  return axios.delete<unknown>(`/journals/${id}`).then(getData);
}
